/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AllowedOrigin, AllowedOrigin$inboundSchema } from "./allowedorigin.js";

export type ListAllowedOriginsResult = {
  /**
   * The list of allowed origins
   */
  allowedOrigins: Array<AllowedOrigin>;
};

/** @internal */
export const ListAllowedOriginsResult$inboundSchema: z.ZodMiniType<
  ListAllowedOriginsResult,
  unknown
> = z.pipe(
  z.object({
    allowed_origins: z.array(AllowedOrigin$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "allowed_origins": "allowedOrigins",
    });
  }),
);

export function listAllowedOriginsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAllowedOriginsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAllowedOriginsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAllowedOriginsResult' from JSON`,
  );
}
